import { render, staticRenderFns } from "./LatestPeriodical.vue?vue&type=template&id=0dc4173a&scoped=true"
import script from "./LatestPeriodical.vue?vue&type=script&lang=js"
export * from "./LatestPeriodical.vue?vue&type=script&lang=js"
import style0 from "./LatestPeriodical.vue?vue&type=style&index=0&id=0dc4173a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc4173a",
  null
  
)

export default component.exports